import React, { Component } from 'react';
import ReactGA from 'react-ga';
import Slider from 'react-slick';
import $ from 'jquery';
import _ from 'lodash';
import titleBox from './image/runway/runway_title_text.jpg';

var PrevArrow = React.createClass({
	render: function() {
		return (
			<div className="arrow-prev" onClick={this.props.onClick}></div>
		);
	}
});

var NextArrow = React.createClass({
	render: function() {
		return (
			<div className="arrow-next" onClick={this.props.onClick}></div>
		);
	}
});

class Runway extends Component {
	constructor(props) {
		super(props);
		var self = this;
		this.state = {
			isShowingPulldown: false,
			listingCount: 12,
			brands: [],
			allBrands: [],
			brand: null,
			thumbnailIndex: this.props.thumbnailIndex,
			activeOverlay: false,
			overlayIndex: 0
		};
		this.onScrolling = function() {
			var wrapper = document.getElementById('scrollable-area');
			if(wrapper.scrollHeight - wrapper.offsetHeight <= wrapper.scrollTop + 5) {
				self.setState({
					listingCount: self.state.listingCount+12
				});
			}
		}
	}
	componentWillMount() {
		var self = this;
		_.forEach(this.props.data.brand, function(letter) {
			_.forEach(letter.item, function(brand) {
				self.state.allBrands.push(brand);
			});
		});
		this.setState({
			brands: this.props.data.brand
		});
		if(!this.props.node) {
			ReactGA.set({
				'dimension1': ':mini:fashionweekfw17',
				'dimension2': ':mini',
				'dimension3': ':mini:fashionweekfw17',
				'dimension4': ':mini:fashionweekfw17:runway'
			});
			ReactGA.pageview('/#runway');
		}
	}
	componentDidMount() {
		document.getElementById('scrollable-area').addEventListener("scroll", this.onScrolling);
		if(!!this.props.node) {
			this.selectBrand(this.props.node, this.props.thumbnailIndex);
		}
	}
	componentWillReceiveProps(nextProps) {
		var self = this;
		if(this.props.node !== nextProps.node) {
			if(nextProps.node == null) {
				this.setState({
					listingCount: 12,
					brand: null,
					thumbnailIndex: 0
				});
			} else {
				$.getJSON("https://www.esquirehk.com/action/page/"+nextProps.node+"/0/0/json/(api)/1", function(data) {
					document.getElementById('scrollable-area').scrollTop = 0;
					var nodeId = data.brand[0].item[0].node_id;
					window.history.pushState({page: "runway", node: nodeId, thumbnailIndex: (nextProps.thumbnailIndex||0)}, null, window.location.pathname+"#runway:"+nodeId+":"+_.kebabCase(_.find(self.state.allBrands, {node_id: nodeId}).label)+":"+(nextProps.thumbnailIndex||0)+":"+Object.keys(data.thumbnail)[(nextProps.thumbnailIndex||0)]);
					ReactGA.set({
						'dimension1': ':mini:fashionweekfw17',
						'dimension2': ':mini',
						'dimension3': ':mini:fashionweekfw17',
						'dimension4': ':mini:fashionweekfw17:runway:'+_.kebabCase(_.find(self.state.allBrands, {node_id: nodeId}).label)+":"+Object.keys(data.thumbnail)[(nextProps.thumbnailIndex||0)]
					});
					ReactGA.pageview('/#runway:'+nodeId+":"+_.kebabCase(_.find(self.state.allBrands, {node_id: nodeId}).label)+":"+(nextProps.thumbnailIndex||0)+":"+Object.keys(data.thumbnail)[(nextProps.thumbnailIndex||0)]);
					self.setState({
						listingCount: 12,
						brand: data,
						thumbnailIndex: (nextProps.thumbnailIndex||0)
					});
				});
			}
		} else if(this.state.brand == null) {
			$.getJSON("https://www.esquirehk.com/action/page/"+nextProps.node+"/0/0/json/(api)/1", function(data) {
				document.getElementById('scrollable-area').scrollTop = 0;
				var nodeId = data.brand[0].item[0].node_id;
				window.history.pushState({page: "runway", node: nodeId, thumbnailIndex: (nextProps.thumbnailIndex||0)}, null, window.location.pathname+"#runway:"+nodeId+":"+_.kebabCase(_.find(self.state.allBrands, {node_id: nodeId}).label)+":"+(nextProps.thumbnailIndex||0)+":"+Object.keys(data.thumbnail)[(nextProps.thumbnailIndex||0)]);
				ReactGA.set({
					'dimension1': ':mini:fashionweekfw17',
					'dimension2': ':mini',
					'dimension3': ':mini:fashionweekfw17',
					'dimension4': ':mini:fashionweekfw17:runway:'+_.kebabCase(_.find(self.state.allBrands, {node_id: nodeId}).label)+":"+Object.keys(data.thumbnail)[(nextProps.thumbnailIndex||0)]
				});
				ReactGA.pageview('/#runway:'+nodeId+":"+_.kebabCase(_.find(self.state.allBrands, {node_id: nodeId}).label)+":"+(nextProps.thumbnailIndex||0)+":"+Object.keys(data.thumbnail)[(nextProps.thumbnailIndex||0)]);
				self.setState({
					listingCount: 12,
					brand: data,
					thumbnailIndex: (nextProps.thumbnailIndex||0)
				});
			});
		} else if(this.props.thumbnailIndex !== undefined && parseInt(this.props.thumbnailIndex, 10) !== nextProps.thumbnailIndex) {
			this.setState({
				thumbnailIndex: nextProps.thumbnailIndex
			});
		}
	}
	componentDidUpdate(prevProps, prevState) {
		if(!!this.refs.slider) {
			this.refs.slider.slickGoTo(this.state.overlayIndex);
		}
	}
	componentWillUnmount() {
		document.getElementById('scrollable-area').removeEventListener("scroll", this.onScrolling);
	}
	showPulldownView() {
		this.setState({
			isShowingPulldown: !this.state.isShowingPulldown
		});
	}
	jumpToKey(key, event) {
		event.stopPropagation();
		document.getElementById("brand-"+key).scrollIntoView(true);
	}
	clickBrand(id) {
		this.selectBrand(id, 0);
	}
	changeSelect(event) {
		this.selectBrand(event.target.value, 0);
	}
	selectBrand(id, thumbnailIndex) {
		this.props.parent.setSubPageData({node: id, thumbnailIndex: thumbnailIndex});
	}
	unselectBrand() {
		document.getElementById('scrollable-area').scrollTop = 0;
		this.props.parent.setSubPageData({node: null});
		window.history.pushState({page: "runway", node: null}, null, window.location.pathname+"#runway");
		ReactGA.set({
			'dimension1': ':mini:fashionweekfw17',
			'dimension2': ':mini',
			'dimension3': ':mini:fashionweekfw17',
			'dimension4': ':mini:fashionweekfw17:runway'
		});
		ReactGA.pageview('/#runway');
	}
	changeThumbnailIndex(index) {
		var nodeId = this.state.brand.brand[0].item[0].node_id;
		window.history.pushState({page: "runway", node: nodeId, thumbnailIndex: index}, null, window.location.pathname+"#runway:"+nodeId+":"+_.kebabCase(_.find(this.state.allBrands, {node_id: nodeId}).label)+":"+index+":"+Object.keys(this.state.brand.thumbnail)[index]);
		ReactGA.set({
			'dimension1': ':mini:fashionweekfw17',
			'dimension2': ':mini',
			'dimension3': ':mini:fashionweekfw17',
			'dimension4': ':mini:fashionweekfw17:runway:'+_.kebabCase(_.find(this.state.allBrands, {node_id: nodeId}).label)+":"+Object.keys(this.state.brand.thumbnail)[index]
		});
		ReactGA.pageview('/#runway:'+nodeId+":"+_.kebabCase(_.find(this.state.allBrands, {node_id: nodeId}).label)+":"+index+":"+Object.keys(this.state.brand.thumbnail)[index]);
		this.props.parent.setSubPageData({thumbnailIndex: index});
	}
	openOverlay(index) {
		this.setState({
			activeOverlay: true,
			overlayIndex: index
		});
	}
	closeOverlay() {
		this.setState({
			activeOverlay: false
		});
	}
	sliderIndexAfterChange(index) {
		var nodeId = this.state.brand.brand[0].item[0].node_id;
		ReactGA.set({
			'dimension1': ':mini:fashionweekfw17',
			'dimension2': ':mini',
			'dimension3': ':mini:fashionweekfw17',
			'dimension4': ':mini:fashionweekfw17:runway:'+_.kebabCase(_.find(this.state.allBrands, {node_id: nodeId}).label)+":"+Object.keys(this.state.brand.thumbnail)[this.state.thumbnailIndex]+":"+this.state.brand.thumbnail[Object.keys(this.state.brand.thumbnail)[this.state.thumbnailIndex]][index].node_id
		});
		ReactGA.pageview('/#runway:'+nodeId+":"+_.kebabCase(_.find(this.state.allBrands, {node_id: nodeId}).label)+":"+this.state.thumbnailIndex+":"+Object.keys(this.state.brand.thumbnail)[this.state.thumbnailIndex]);
	}
	render() {
		var self = this;
		return (
			<div className="runway">
				{
					(this.state.brand == null) ?
						null
					:
						<div className={"overlay"+(this.state.activeOverlay ? " active" : "")}>
							<div className="mask">
								<div className="block">
									<div className="close-btn" onClick={this.closeOverlay.bind(this)}></div>
									<Slider ref="slider" className="slider" lazyLoad={true} prevArrow={<PrevArrow />} nextArrow={<NextArrow />} afterChange={this.sliderIndexAfterChange.bind(this)}>
										{
											this.state.brand.thumbnail[Object.keys(this.state.brand.thumbnail)[this.state.thumbnailIndex]].map(function(photo, index) {
												return (
													<div key={index} className="slide">
														<div className="slide-image" style={{backgroundImage: "url("+photo.image+")"}}></div>
													</div>
												)
											})
										}
									</Slider>
								</div>
							</div>
						</div>
				}
				<div className="sub-page-header">
					<div className="sub-page-title">
						<div>
							<img src={titleBox} alt="RUNWAY" onClick={this.unselectBrand.bind(this)} />
						</div>
					</div>
				</div>
				<div className="sub-page-content">
					<div className="graphic">
						<div className="graphic1"></div>
						<div className="graphic2"></div>
					</div>
					<div id="scrollable-area" className="scrollable-area">
						<div className="pulldown" onClick={this.showPulldownView.bind(this)}>
							<div className={"pulldown-container"+(this.state.isShowingPulldown ? " active" : "")}>
								<div id="brandList" className="brand-list">
									{
										this.state.brands.map(function(letter, index) {
											return (
												<div key={index} id={"brand-"+letter.key}>
													{
														letter.item.map(function(brand, index) {
															return (
																<div key={index} className="brand" onClick={self.clickBrand.bind(self, brand.node_id)}>{brand.label}</div>
															)
														})
													}
												</div>
											)
										})
									}
								</div>
								<div className="alphabet-order">
									{
										_.range(65, 91).map(function(i, index) {
											return (
												<div key={index} className="alphabet" onClick={self.jumpToKey.bind(self, String.fromCharCode(i))}>{String.fromCharCode(i)}</div>
											)
										})
									}
									<div className="alphabet" onClick={this.jumpToKey.bind(self, "#")}>#</div>
								</div>
							</div>
						</div>
						<select className="brand-select" defaultValue="" onChange={this.changeSelect.bind(this)}>
							<option value="" disabled>A-Z</option>
							{
								this.state.brands.map(function(letter, index) {
									return letter.item.map(function(brand, index) {
										return (
											<option key={index} value={brand.node_id}>{brand.label}</option>
										)
									})

								})
							}
						</select>
						{
							(this.state.brand == null) ?
								<div className="brands">
									{

											_.take(this.state.allBrands, this.state.listingCount).map(function(brand, index) {
												return (
													<div key={index} id={"brand-"+brand.node_id} className="brand" onClick={self.clickBrand.bind(self, brand.node_id)}>
														<div className="brand-image" style={{backgroundImage: "url("+brand.image+")"}}></div>
														<div className="brand-name">{brand.label}</div>
													</div>
												)
											})

									}
								</div>
							:
								<div className="brand-detail">
									<h1>{this.state.brand.brand[0].item[0].label}</h1>
									<div className="thumbnails">
										{
											Object.keys(this.state.brand.thumbnail).map(function(key, index) {
												return (
													<span key={index} className={"thumbnail"+(self.state.thumbnailIndex === index ? " active" : "")} onClick={self.changeThumbnailIndex.bind(self, index)}>{key}</span>
												)
											})
										}
									</div>
									<div className="photos">
										{
											_.take(this.state.brand.thumbnail[Object.keys(this.state.brand.thumbnail)[this.state.thumbnailIndex]], this.state.listingCount).map(function(photo, index) {
												return (
													<div key={index} className="photo">
														<div className="photo-image" style={{backgroundImage: "url("+photo.image+")"}} onClick={self.openOverlay.bind(self, index)}></div>
													</div>
												)
											})
										}
									</div>
								</div>
						}
					</div>
				</div>
				<div className="fixed-on-bottom">
					<div className="fixed-esky-container">
						<div className="fixed-esky"></div>
					</div>
				</div>
			</div>
		);
	}
}

export default Runway;


// WEBPACK FOOTER //
// ./src/Runway.js